import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";

const AccountPage = ({ children }) => (
	<Container className="account-page">
		<div className="account-page-background">
			<PaddingX>
				<div className="account-page-container">{children}</div>
			</PaddingX>
		</div>
	</Container>
);

export default AccountPage;
